import { ToolType } from "./ITool.js";
const object3DkeysExclude = ['animations', 'castShadow', 'customDepthMaterial', 'customDistanceMaterial', 'frustumCulled', 'isObject3D', 'layers',
    'matrix', 'matrixAutoUpdate', 'matrixWorld', 'matrixWorldAutoUpdate', 'matrixWorldNeedsUpdate', 'name', 'parent', 'receiveShadow',
    'renderOrder', 'type', 'up', 'uuid', '_eventHandler', '_userData', 'isPressed', 'interceptedByRaycaster', 'isSelected', 'isDraggable', 'isDragging',
    'isHovered', '_listeners', '__saveKeysChildren', '__saveKeys',
    'geometry', 'material', 'count', 'morphTargetDictionary', 'morphTargetInfluences', 'isMesh', 'isLine',
    'isLine2', 'isLineSegments2', 'isSprite', 'isGroup', 'quaternion'];
export const HistoryRules = [
    {
        isCallback: (obj) => obj.isLabel, // TODO we can remove it when will do the decorator to avoid tracking some properties
        exclude: new Set(['_context', '_canvas', '_objToAnchor', ...object3DkeysExclude])
    },
    {
        isCallback: (obj) => obj.isObject3D,
        exclude: new Set(object3DkeysExclude),
        include: ['contrast', 'brightness'] // these are getter, that's why we need to include them
    },
    {
        isCallback: (obj) => obj.toolType === ToolType.plane,
        exclude: new Set(), // TODO this should be nullable
        include: ['contrast', 'brightness'] // these are getter, that's why we need to include them
    },
    {
        isCallback: (obj) => obj.isVector3,
        exclude: new Set(['parentEventHandler', 'isVector3', '_x', '_y', '_z'])
    },
    {
        isCallback: (obj) => obj.isEuler,
        exclude: new Set(['parentEventHandler', 'isEuler', '_order', '_x', '_y', '_z', '__x', '__y', '__z']),
        include: ['x', 'y', 'z', 'order'] // these are getter, that's why we need to include them
    },
    {
        isCallback: (obj) => obj.isAppModel,
        exclude: new Set(['measures', '_context', '_history', '_links', 'isMeasurementToolSelectedAP', 'isMeasurementToolSelectedLT']),
    }
];
//# sourceMappingURL=HistoryRules.js.map